"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageInput = void 0;
var core_1 = require("@newfront-insurance/core");
var core_ui_1 = require("@newfront-insurance/core-ui");
var coverage_api_1 = require("@newfront-insurance/coverage-api");
var dsl_schema_ui_1 = require("@newfront-insurance/dsl-schema-ui");
var formik_1 = require("formik");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importStar(require("react"));
var line_of_coverage_metadata_1 = require("../../hooks/line-of-coverage-metadata");
function propertyKey(rootPropertyName, propertyName) {
    return rootPropertyName + "." + propertyName;
}
function globalFieldsNestedKey(rootPropertyName, globalFieldsNestedPropertyName) {
    return rootPropertyName + ".globalFields." + globalFieldsNestedPropertyName;
}
function CoverageInput(_a) {
    var name = _a.name, lineOfCoverageType = _a.lineOfCoverageType, lineOfCoverageVersion = _a.lineOfCoverageVersion;
    // Important: Remember to surround with suspense to deal with the async waiting period rendered component
    var data = line_of_coverage_metadata_1.useLineOfCoverageMetadata({ lineOfCoverageType: lineOfCoverageType, lineOfCoverageVersion: lineOfCoverageVersion }, { suspense: true }).data;
    var _b = formik_1.useFormikContext(), values = _b.values, errors = _b.errors, setFieldValue = _b.setFieldValue;
    // make sure we always have at least an empty object in "data"
    react_1.useEffect(function () {
        var formValuesData = get_1.default(values, propertyKey(name, 'data'));
        if (!formValuesData) {
            setFieldValue(propertyKey(name, 'data'), {});
        }
    }, [setFieldValue, name, values]);
    // set "type" and keep it updated
    react_1.useEffect(function () {
        setFieldValue(propertyKey(name, 'type'), lineOfCoverageType);
    }, [setFieldValue, name, lineOfCoverageType]);
    // set "version" and keep it updated
    react_1.useEffect(function () {
        if (!data)
            return;
        var formValuesVersion = get_1.default(values, propertyKey(name, 'version'));
        if (core_1.isNil(formValuesVersion) && core_1.isNil(lineOfCoverageVersion)) {
            // use the fetched "currentVersion" if no version is set in the form and no explicit version was passed to the component
            setFieldValue(propertyKey(name, 'version'), data.definition.currentVersion);
        }
        else if (core_1.isNotNil(lineOfCoverageVersion) && lineOfCoverageVersion !== formValuesVersion) {
            // use the explicit version passed to the component if no version is set in the form
            setFieldValue(propertyKey(name, 'version'), lineOfCoverageVersion);
        }
    }, [lineOfCoverageVersion, values, setFieldValue, data, name]);
    // manage "displayName" changes
    var handleDisplayNameChange = function (value) {
        setFieldValue(propertyKey(name, 'displayName'), value);
    };
    var claimsMadeOrOccurrence = globalFieldsNestedKey(name, 'claimsMadeOrOccurrence');
    var coverageTerritory = globalFieldsNestedKey(name, 'coverageTerritory');
    var auditable = globalFieldsNestedKey(name, 'auditable');
    var terrorismRiskInsuranceAct = globalFieldsNestedKey(name, 'terrorismRiskInsuranceAct');
    var additionalDetails = globalFieldsNestedKey(name, 'additionalDetails');
    // return the input to add information into the "data" object, which must follow the structure determined by the schema
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 32, direction: "vertical" },
        react_1.default.createElement(core_ui_1.Field, { key: propertyKey(name, 'displayName'), fieldId: propertyKey(name, 'displayName'), label: "Display name", error: get_1.default(errors, propertyKey(name, 'displayName')) },
            react_1.default.createElement(core_ui_1.Input, { type: "text", value: get_1.default(values, propertyKey(name, 'displayName')), onChange: handleDisplayNameChange })),
        react_1.default.createElement(core_ui_1.Field, { fieldId: claimsMadeOrOccurrence, label: "" },
            react_1.default.createElement(core_ui_1.RadioButtonGroup, { name: "claimsMadeOrOccurrence", value: get_1.default(values, claimsMadeOrOccurrence), options: coverage_api_1.claimsMadeOrOccurrenceOptions, onChange: function (value) { return setFieldValue(claimsMadeOrOccurrence, value); } })),
        react_1.default.createElement(core_ui_1.Field, { fieldId: coverageTerritory, label: "Coverage Territory" },
            react_1.default.createElement(core_ui_1.RadioButtonGroup, { name: "coverageTerritory", value: get_1.default(values, coverageTerritory), options: coverage_api_1.coverageTerritoryTypeOptions, onChange: function (value) { return setFieldValue(coverageTerritory, value); } })),
        react_1.default.createElement(core_ui_1.Field, { fieldId: auditable, label: "Auditable?" },
            react_1.default.createElement(core_ui_1.AdvancedSelectInput, { value: get_1.default(values, auditable), options: coverage_api_1.auditableTypeOptions, onChange: function (value) { return setFieldValue(auditable, value); } })),
        react_1.default.createElement(dsl_schema_ui_1.FormikSchemaInput, { name: propertyKey(name, 'data'), schema: data === null || data === void 0 ? void 0 : data.schema }),
        react_1.default.createElement(core_ui_1.Field, { fieldId: terrorismRiskInsuranceAct, label: "Terrorism Risk Insurance Act (TRIA)" },
            react_1.default.createElement(core_ui_1.AdvancedSelectInput, { value: get_1.default(values, terrorismRiskInsuranceAct), options: coverage_api_1.terrorismRiskInsuranceActTypeOptions, onChange: function (value) { return setFieldValue(terrorismRiskInsuranceAct, value); } })),
        react_1.default.createElement(core_ui_1.Field, { fieldId: additionalDetails, label: "Additional Details" },
            react_1.default.createElement(core_ui_1.TextareaAutosize, { "data-testid": additionalDetails, value: get_1.default(values, additionalDetails), onChange: function (event) { return setFieldValue(additionalDetails, event.target.value); } }))));
}
exports.CoverageInput = CoverageInput;
